<ion-list  >
  @for (reportList of reportList; track reportList) {
    <ion-item lines="none"  >
      <ion-label (click)="submitReport(reportList.Name,reportList.Id,PropertyId)">{{reportList.Name}}</ion-label>
    </ion-item>
  }
</ion-list>

